import { faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Divider, Flex, Text, TextButton } from '@modusign/design-system';

interface ContactsUtilityBarProps {
  contactIds: string[];
  onDelete: () => void;
  onReset: () => void;
}

export default function ContactsUtilityBar({
  contactIds,
  onDelete,
  onReset,
}: ContactsUtilityBarProps) {
  return (
    <Flex
      alignItems="center"
      bg="boxBackgroundEmphasisBase"
      borderRadius="4px"
      display={['none', null, 'flex']}
      flexWrap="wrap"
      gap={2}
      mb={7}
      px={4}
      py={5}
      width="100%"
    >
      <Text as="p" fontWeight="medium">
        선택한 연락처
      </Text>
      <Text
        bg="statusBackgroundEmphasisDark"
        color="textNeutralLightest"
        data-testid="address-book-checked-contact-count"
        fontSize="xs"
        fontWeight="medium"
        px={3}
        py={1}
        sx={{ borderRadius: '12px' }}
        textAlign="center"
      >
        {contactIds.length}
      </Text>
      <Flex ml={2}>
        <TextButton textDecoration="plain" onClick={onDelete}>
          <Box as="span" mr={2}>
            <FontAwesomeIcon icon={faTrashCan} />
          </Box>
          삭제
        </TextButton>
        <Box>
          <Divider color="base" direction="column" mx={4} />
        </Box>
        <TextButton textDecoration="plain" onClick={onReset}>
          선택 취소
        </TextButton>
      </Flex>
    </Flex>
  );
}
